import React, { useRef, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import apiUrl from "../../Apiurl";
import stilePulsanti from "../../interfaccia/stilePulsanti";
import { TextSkeleton } from "../../interfaccia/loading";

function TXTuploadImportOrdiniAmazon({ setPopUpWindow }) {
  const [fileNonSpediti, setFileNonSpediti] = useState(null);
  const [fileCompleto, setFileCompleto] = useState(null);
  const [inCaricamento, setInCaricamento] = useState(false);
  const [errore, setErrore] = useState("");
  const [risultato, setRisultato] = useState(null);
  const richiestaInCorso = useRef(false);
  const { getAccessTokenSilently } = useAuth0();

  const selezionaFile = (event, setter) => {
    const file = event.target.files?.[0] || null;
    setErrore("");
    setRisultato(null);
    if (file && !/\.txt$/i.test(file.name) && file.type !== "text/plain") {
      setter(null);
      event.target.value = "";
      setErrore("Seleziona un report TXT (.txt o text/plain).");
      return;
    }
    setter(file);
  };

  const handleSubmission = async () => {
    if (!fileNonSpediti || !fileCompleto || richiestaInCorso.current) return;
    richiestaInCorso.current = true;
    setInCaricamento(true);
    setErrore("");
    setRisultato(null);
    try {
      const token = await getAccessTokenSilently();
      const formData = new FormData();
      formData.append("file_non_spediti", fileNonSpediti);
      formData.append("file_completo", fileCompleto);
      const resp = await axios.post(
        apiUrl + "/logistica/csv/importOrdiniAmazon",
        formData,
        { headers: { Authorization: "Bearer " + token } },
      );
      setRisultato(resp.data || {});
    } catch (error) {
      const dati = error?.response?.data;
      const dettaglio = dati?.missing_permission
        ? "Permesso mancante: " + dati.missing_permission
        : [dati?.error, dati?.detail].filter(Boolean).join(" — ") ||
          error.message || "Errore imprevisto";
      setErrore("Errore durante l'import: " + dettaglio);
    } finally {
      richiestaInCorso.current = false;
      setInCaricamento(false);
    }
  };

  return (
    <div className="pa3 shadow-5 br4 max70 sezioneConScroll">
      {setPopUpWindow && (
        <button
          type="button"
          aria-label="Chiudi import ordini Amazon"
          className="dim tastoInputOrizzontale br3"
          onClick={() => setPopUpWindow(false)}
        >
          {stilePulsanti.tastoChiudiAspetto}
        </button>
      )}
      <h1>Import ordini Amazon (TXT)</h1>
      <p>
        Da usare quando il collegamento Amazon → PrestaShop è fermo. Scarica da
        Seller Central i due report: “Ordini non spediti” contiene gli indirizzi,
        “Ordini” completo contiene i prezzi. Caricali nei rispettivi campi.
      </p>
      <p>
        Gli ordini già presenti in Domino per riferimento marketplace vengono
        saltati. Il magazzino di partenza viene deciso dalle giacenze Domino.
        Gli ordini con avvisi vanno controllati dopo l'import.
      </p>
      <div className="flex flex-column flex-row-ns">
        <div className="w-100 w-50-ns pa3">
          <label className="db mb3">
            Report ordini non spediti (.txt)
            <input
              className="db mt2 mw-100"
              type="file"
              accept=".txt,text/plain"
              name="file_non_spediti"
              disabled={inCaricamento}
              onChange={(event) => selezionaFile(event, setFileNonSpediti)}
            />
          </label>
          <label className="db mb3">
            Report ordini completo (.txt)
            <input
              className="db mt2 mw-100"
              type="file"
              accept=".txt,text/plain"
              name="file_completo"
              disabled={inCaricamento}
              onChange={(event) => selezionaFile(event, setFileCompleto)}
            />
          </label>
          <button
            type="button"
            className="tastoInputOrizzontale br3 dim ph3 pv2"
            disabled={!fileNonSpediti || !fileCompleto || inCaricamento}
            onClick={handleSubmission}
          >
            Carica
          </button>
          {errore && <p role="alert">{errore}</p>}
          <div aria-live="polite" aria-busy={inCaricamento}>
            {inCaricamento && (
              <div className="mt3" role="status" aria-label="Import Amazon in corso">
                <TextSkeleton lines={4} />
              </div>
            )}
            {risultato && (
              <div>
                <h2>Import completato</h2>
                <p>Righe lette: {risultato.righeLette ?? 0}</p>
                <ul>
                  <li>Inseriti: {risultato.arrOrdiniInseriti?.length ?? 0}</li>
                  <li>Già presenti: {risultato.arrOrdiniPresenti?.length ?? 0}</li>
                  <li>Errori: {risultato.arrErrori?.length ?? 0}</li>
                  <li>Avvisi: {risultato.avvisi?.length ?? 0}</li>
                </ul>
                {!!risultato.arrErrori?.length && (
                  <>
                    <h3>Errori</h3>
                    <ul>
                      {risultato.arrErrori.map((item, index) => (
                        <li key={index}>
                          {[item.idPS != null && `ID PS ${item.idPS}`, item.fase,
                            item.codice, item.messaggio].filter(Boolean).join(" — ")}
                        </li>
                      ))}
                    </ul>
                  </>
                )}
                {!!risultato.avvisi?.length && (
                  <>
                    <h3>Avvisi: controllare gli ordini indicati</h3>
                    <ul>
                      {risultato.avvisi.map((item, index) => (
                        <li key={index}>
                          {[item.rifMarketplace, item.sku && `SKU ${item.sku}`,
                            item.messaggio].filter(Boolean).join(" — ")}
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="w-100 w-50-ns pa3 bl-ns bordoColAlt">
          {risultato && (
            <details>
              <summary>Risposta completa (JSON)</summary>
              <pre className="pa3 max70 sezioneConScroll">
                {JSON.stringify(risultato, null, 2)}
              </pre>
            </details>
          )}
        </div>
      </div>
    </div>
  );
}

export default TXTuploadImportOrdiniAmazon;
